import { createStore } from "vuex";
// import { SideMenuStore } from "./module/SideMenuStore";
// import { AccountStore } from "./module/AccountStore.js";

export default createStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        // sideMenu: SideMenuStore,
        // account: AccountStore,
    }
});
